// ============================================================================
// layer.dailys.index — the layer daily hub, off App's boot arrays
// ============================================================================
// Two obligations, and they arrived from two different owners.
//
//   layer.dailys.list             the hub's own full-history page sequence.
//                                 Presenter-owned before; only the cursor moved.
//   layer.dailys.groupDirectory   the ppp-layer-groups-v1 blob and the two
//                                 layer directories, which reached this surface
//                                 as a LayerEntry prop carrying App's
//                                 former-eager boot results. Removing that
//                                 hand-off is what retires `layerdailys` from
//                                 all three frozen consumer lists in
//                                 tests/fixtures/former-eager-dependencies.json.
//
// The directory resource is declared by BOTH daily surfaces because
// LayerDailysRouter reads it above the index/record branch — the same place the
// prop used to land. A resource may only name surfaces the manifest declares
// migrated, so the record page had to move in the same change; see
// layer.dailys.detail.ts.
//
// Saved views are not an obligation here for the same reason they are not one
// on layer.batches.index: useSavedViewsData owns that read for every surface
// that has a picker.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'layer.dailys.index',
  obligations: Object.freeze([
    Object.freeze({id: 'layer.dailys.list', owner: 'permanent'}),
    Object.freeze({id: 'layer.dailys.groupDirectory', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
